import { Col, Row, Spin } from "antd";
import type { JSX } from "react";

export default function Loading(): JSX.Element {
  return (
    <div className="loading-container">
      <Row>
        <Col span={12} offset="3">
          <div className="text-center">
            <Spin size="large" />
          </div>
        </Col>
      </Row>
    </div>
  );
}
